import React from "react";
import UserQuestions from "../../ask-a-nurse/UserQuestions";

function Step4({ data, allData, step }: any) {
  return <UserQuestions />;
}

export default Step4;
